import { useChainId } from 'wagmi'

import { withSuspense } from '@/ui/utils/withSuspense'

import { SwapSkeleton } from './components/skeleton/SwapSkeleton'
import { SwapSuccessView } from './views/SwapSuccessView'
import { SwapView } from './views/SwapView'
import { useSwap } from './logic/useSwap'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
interface SwapContainerProps {
  isModal: boolean
  withHeading?: boolean
  filterZeroBalance?: boolean
  toTokens?: Token[]
  simplified?: boolean
  featuredToAssets?: TokenSymbol[]
}

function SwapContainer({
  withHeading,
  isModal,
  filterZeroBalance,
  simplified,
  toTokens,
  featuredToAssets,
}: SwapContainerProps) {
  const swap = useSwap({ isModal, filterZeroBalance, toTokens })

  if (swap.pageStatus.state === 'success') {
    return (
      <SwapSuccessView
        runConfetti={false}
        resetForm={swap.pageStatus.resetForm}
        swapMode={swap.swapMode}
        fromToken={swap.fromToken}
        toToken={swap.toToken}
        isModal={isModal}
      />
    )
  }

  return (
    <SwapView
      swap={swap}
      withHeading={withHeading}
      simplified={simplified}
      toTokens={toTokens}
      featuredToAssets={featuredToAssets}
    />
  )
}

// @note: forces form to reset when network changes
function SwapContainerWithKey(props: SwapContainerProps) {
  const chainId = useChainId()
  return <SwapContainer key={chainId} {...props} />
}

const SwapContainerWithSuspense = withSuspense(SwapContainerWithKey, SwapSkeleton)

export { SwapContainerWithSuspense as SwapContainer }
